<template>
  <BBPCheckbox :title="input.title"
               :defaultValue="checked"
               :disable="input.disabled"
               @change="changeValue"
  />
</template>

<script>
import BBPCheckbox from '@/components/Main/InputFields/BBPCheckbox/BBPCheckbox'
import {get} from 'lodash'

export default {
  name: 'BBPCheckboxForm',
  props: ['input', 'model', 'errorText'],
  components: {
    BBPCheckbox
  },
  data () {
    return {
      checked: false
    }
  },
  methods: {
    changeValue ({value}) {
      this.checked = value
    },
    setDefaultValue () {
      this.checked = get(this.model, this.input.model, false)
    }
  },
  watch: {
    checked () {
      this.$emit('input', this.checked)
    }
  },
  beforeMount () {
    this.setDefaultValue()
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPForm/BBPCheckboxForm/BBPCheckboxForm.vue